import eventBus from 'toxilibs/event_bus_queued.js'
import Timer from 'toxilibs/timer.js'
import answerCheck from './answer_check.js'

function Challenge (params) {

    this.levelID    = params.levelID
    this.questionID = params.questionID

    this.fullLabel = this.levelID + '_' + this.questionID


    this.question = params.question.generate()
    this.answer   = this.question.answer

    if (typeof this.answer === 'number') {
        this.answer = Math.round(this.answer * 10000) / 10000
    }

    this.callback = params.callback


    initTimer(this, params)

    eventBus.emit('challenge created', this)

}





//************************** TIMER **************************

function initTimer (challenge, params) {

    params.noTimer = true //FIXME NO TIMER !

    if (!params.noTimer) {
        params.endCallback = function () {
            challenge.tooLate()
        }
    }

    params.duration = params.timeoutTime

    challenge.timer = new Timer(params)
    challenge.timer.launch()
}


Challenge.prototype.pause = function () {
    this.timer.pause()
}


Challenge.prototype.unPause = function () {
    this.timer.unPause()
}





//************************** ANSWERING AND END **************************


Challenge.prototype.tooLate = function () {
    this.wasTooLate = true
    this.afterAnswer(null, 'tooLate')
}



function formatedUserAnswer (answer, userAnswer, win) {

    if (userAnswer === 'ooo') {
        userAnswer = answer
    }

    if (isMeantToBeAString(userAnswer)) {   // FIXME: if userAnswer === 'ooo' then it can be equal to true and not 'true'
        userAnswer = "'" + userAnswer + "'" // TODO: handle other language keyWords (True False), must be done only if userAnswer is a string
    }

    if (typeof answer === 'string' && win) {
        userAnswer = "'" + answer + "'"
    }


    return userAnswer
}


function isMeantToBeAString (userAnswer) {
    return isNaN(parseInt(userAnswer, 10)) && userAnswer !== 'false' && userAnswer !== 'true'
}


Challenge.prototype.submitAnswer = function (userAnswer) {
    this.pause()

    if (this.answerSubmitted || this.wasTooLate) {
        return
    }

    this.answerSubmitted = true

    userAnswer = answerCheck.cleanAnswer(userAnswer)

    const win = answerCheck.isCorrect(this.answer, userAnswer)

    userAnswer = formatedUserAnswer(this.answer, userAnswer, win)

    let status = (win ? 'win' : 'lose')

    if (userAnswer === "'helpMe'") {
        status = 'withHelp'
    }

    this.afterAnswer(userAnswer, status)

}


Challenge.prototype.afterAnswer = function (userAnswer, status) {

    this.totalTime = this.timer.totalTime()

    eventBus.emit('challenge answer given', this, userAnswer, status)

    const challenge = this

    setTimeout(function () {
        if (challenge.destroyed) { // the player went to another level during the correction
            return
        }
        eventBus.emit('challenge after answer phase ended', challenge) //FIXME bad naming
        challenge.callback(status)
    }, status === 'win' ? 1500 : 2000)
}


Challenge.prototype.destroy = function () {
    this.destroyed = true
    this.pause()
    eventBus.emit('challenge destroyed', this)
}







export default Challenge

